import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

@Pipe({
  name: "age",
})
export class AgePipe implements PipeTransform {
  transform(value: any): string {
    if (value) {
      let convertedDate = new Date(value);
      let today = moment();
      let birthDate = moment(convertedDate);
      let years = today.diff(birthDate, "years");
      let ageStr: string = years + " year(s) ";
      ageStr += today.subtract(years, "years").diff(birthDate, "months") + " months";
      return ageStr;
      // return ageStr +" months";
    }

    return null;
  }
}
